import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
// import { clearUser } from "../features/user/UserSlice";

const PrivateRoute = ({ element, roles }) => {
  // return element;
  const { user } = useSelector((state) => state?.userInfo);

  // const token = localStorage.getItem("token");

  // const location = useLocation();
  // const dispatch = useDispatch();

  // if (!token) {
  //   dispatch(clearUser());
  //   return <Navigate to="/sign-in" state={{ from: location }} />;
  // }

  if (!user) {
    return <Navigate to="/sign-in" />;
  }

  // if (roles && roles !== user?.role) {
  //   return <Navigate to="/unauthorized" />;
  // }

  if (roles && !roles.includes(user?.role)) {
    return <Navigate to="/unauthorized" />;
  }

  return element;
};

export default PrivateRoute;
